import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NextPageRoute } from "@cvx/nextpage";
import { NoAccessComponent } from "./authentication/no-access/no-access.component";
import { HomeComponent } from "./home/home.component";
import { OperationsDashboardComponent } from "./operations-dashboard/operations-dashboard.component";
import { RheologicalHierarchyComponent } from "./rheological-hierarchy/rheological-hierarchy.component";
import { FaqComponent } from "./faq/faq.component";
import { RedesignMetricsComponent } from "./redesign-metrics/redesign-metrics.component";
import { ProjectsDashboardComponent } from "./projects-dashboard/projects-dashboard.component";
import { WellRedesignReportComponent } from "./projects-dashboard/well-redesign-report/well-redesign-report.component";
import { CreateNewProjectDialogComponent } from "./projects-dashboard/create-new-project-dialog/create-new-project-dialog.component";
import { SlurryDetailsComponent } from "./project-details/slurry-details/slurry-details.component";
import { SlurryBatchDetailsComponent } from "./project-details/slurry-batch-details/slurry-batch-details.component";
import { SLURRY_NAVIGATION_CONTEXT_DATA_KEY } from "./project-details/slurry-details/slurry-routing";
import { SlurryViewComponent } from "./project-details/slurry-view/slurry-view.component";
import { SpacerDetailsComponent } from "./project-details/spacer-details/spacer-details.component";
import { CreateSpacerInfoComponent } from "./project-details/add-new-spacer-modal/create-spacer-info/create-spacer-info.component";
import { LabAuditChecklistComponent } from "./lab-audit-checklist/lab-audit-checklist.component";
import { LabDocumentationComponent } from "./lab-documentation/lab-documentation.component";
import { LabEquipmentComponent } from "./lab-equipment/lab-equipment.component";
import { InstrumentDetailsComponent } from "./lab-equipment/instrument-details.component";
import { UserGuideComponent } from "./user-guide/user-guide.component";
import { InstrumentTypeMatrixComponent } from "./lab-equipment/instrument-type-matrix.component";
import { YearlyCalibrationCertificatesComponent } from "./yearly-calibration-certificates/yearly-calibration-certificates.component";
import { YearlyCalibrationCertificateDetailsComponent } from "./yearly-calibration-certificates/yearly-calibration-certificate-details.component";


export const menuRoutes: NextPageRoute[] = [
  { path: "home", component: HomeComponent, title: "Home" },
  { path: "projects-dashboard", component: ProjectsDashboardComponent, title: "Projects Dashboard" },
  { path: "operations-dashboard", component: OperationsDashboardComponent, title: "Operations Dashboard" },
  { path: "rheological-hierarchy", component: RheologicalHierarchyComponent, title: "Rheological Hierarchy" },
  // { path: "faq", component: FaqComponent, title: "FAQ" },
  { path: "user-guide", component: UserGuideComponent, title: "User Guide" },
  { path: "redesign-metrics", component: RedesignMetricsComponent, title: "Redesign Metrics" },
  { path: "lab-documentation", component: LabDocumentationComponent, title: "Lab Documentation" },
  { path: "lab-audit-checklist", component: LabAuditChecklistComponent, title: "Lab Audit Checklist" },
  { path: "lab-equipment", component: LabEquipmentComponent, title: "Lab Equipment" },
  { path: "yearly-calibration-certificates", component: YearlyCalibrationCertificatesComponent, title: "Yearly Calibration Certificates" }
];

const routerRoutes: NextPageRoute[] = [
  { path: "", redirectTo: "/home", pathMatch: "full" },
  { path: "no-access", component: NoAccessComponent },
  { path: "well-redesign-report/:wellId", component: WellRedesignReportComponent },
  { path: "create-new-project", component: CreateNewProjectDialogComponent },
  { path: "lab-equipment/types", component: InstrumentTypeMatrixComponent, title: "Lab Calibration Types" },
  { path: "lab-equipment/:id", component: InstrumentDetailsComponent, title: "Lab Equipment Details" },
  {
    path: "yearly-calibration-certificates/:id",
    component: YearlyCalibrationCertificateDetailsComponent,
    title: "Yearly Calibration Certificate Details"
  },
  {
    path: "slurry-details/:slurryId",
    component: SlurryDetailsComponent,
    title: "Slurry Details",
    data: { [SLURRY_NAVIGATION_CONTEXT_DATA_KEY]: "standalone" }
  },
  {
    path: "slurry-details/:slurryId/batches/:batchId",
    component: SlurryBatchDetailsComponent,
    title: "Batch Details",
    data: { [SLURRY_NAVIGATION_CONTEXT_DATA_KEY]: "standalone" }
  },
  ...menuRoutes.filter(r => r.path !== "projects-dashboard"),
  {
    path: "projects-dashboard",
    component: ProjectsDashboardComponent,
    title: "Projects Dashboard",
    children: [
      {
        path: "slurry-details/:slurryId",
        component: SlurryDetailsComponent,
        title: "Slurry Details",
        data: { [SLURRY_NAVIGATION_CONTEXT_DATA_KEY]: "dashboard" }
      },
      {
        path: "slurry-details/:slurryId/batches/:batchId",
        component: SlurryBatchDetailsComponent,
        title: "Batch Details",
        data: { [SLURRY_NAVIGATION_CONTEXT_DATA_KEY]: "dashboard" }
      },
      { path: "slurry-view/:slurryId",    component: SlurryViewComponent,    title: "Slurry View"    },
      { path: "spacer/:projectId/:spacerId", component: SpacerDetailsComponent, title: "Spacer Details" },
      { path: "create-spacer-info/:projectId", component: CreateSpacerInfoComponent, title: "Create Spacer" }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routerRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
